import APP_CONFIG from 'src/config/AppConfig';

export const CONTINENTS = Object.freeze({
  EU: 'EU',
  US: 'US',
});

export const CURRENT_CONTINENT =
  APP_CONFIG.CONTINENT === CONTINENTS.EU ? CONTINENTS.EU : CONTINENTS.US;

export const isEUContinent = APP_CONFIG.CONTINENT === CONTINENTS.EU;

export const ABOUT_COMPANY_INFO = Object.freeze({
  aboutHeader: {
    EU: 'Neteera 130H-Plus EU',
    US: 'Neteera 130H-Plus',
  },
  neteeraCompany: {
    EU: 'Neteera Technologies Ltd.',
    US: 'Neteera Technologies Ltd.',
  },
  neteeraProfessor: {
    EU: 'Prof. Rakah 3 St.',
    US: 'Prof. Rakah 3 St.',
  },
  neteeraAddress: {
    EU: 'Jerusalem, 9270403, Israel',
    US: 'Jerusalem, 9270403, Israel',
  },
  neteeraStaticSite: {
    EU: 'www.neteera.com',
    US: 'www.neteera.com',
  },
  importer: {
    EU: '',
    US: 'US Initial Importer:',
  },
  representativeCompany: {
    EU: '',
    US: 'Hudson Scientific',
  },
  representativeAddress: {
    EU: '',
    US: '103 W Main Street',
  },
  representativeCountryOrState: {
    EU: '',
    US: 'Hudson, MI 49247',
  },
  representativeCountryPhoneNumber: {
    EU: '',
    US: '(517) 212-4047',
  },
  neteeraCompanyName: {
    EU: 'Neteera HealthGate',
    US: 'Neteera HealthGate',
  },
  neteeraAppVersion: {
    EU: '2.6, July-2025',
    US: '2.6, July-2025',
  },
  neteeraContactMail: {
    EU: 'support@neteera.com',
    US: 'support@neteera.com',
  },
  aboutFooter: {
    EU: 'SW-AboutScreenEU Rev. 1.0',
    US: 'SW-AboutScreenUS Rev. 1.0',
  },
});
